import clsx from "clsx";
import shape from "../../assets/img/shapes/radius-shape-01.webp";


const RadiusShape01 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-radius-shape-01", props.className)}>
            <img src={shape} alt="rmdr-radius-shape-01" loading="lazy" width={351} height={339} />
        </div>
    )

}

export default RadiusShape01;
